import React, { useEffect, useMemo, useState } from 'react';
import { fetchFacebookLeads, fetchFacebookAdRoi } from '../services/api';

/**
 * Marketing > Facebook Leads: the admin portal Facebook Leads and Facebook Ad ROI screens on the
 * SQL01 copy (Azure exit WS8). Refreshing spend from Facebook still happens in the admin portal.
 */

const money = (n) => `$${Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function FacebookLeads() {
  const [tab, setTab] = useState('leads');
  const [leads, setLeads] = useState(null);
  const [ads, setAds] = useState(null);
  const [error, setError] = useState(null);
  const [q, setQ] = useState('');
  const [newOnly, setNewOnly] = useState('all');

  useEffect(() => {
    Promise.all([fetchFacebookLeads(), fetchFacebookAdRoi()])
      .then(([l, a]) => { setLeads(l); setAds(a); })
      .catch((e) => setError(e.message));
  }, []);

  const needle = q.trim().toLowerCase();
  const shownLeads = useMemo(() => (leads || [])
    .filter((r) => newOnly === 'all' || r.newCustomer === newOnly)
    .filter((r) => !needle || `${r.email} ${r.adName} ${r.campaignName} ${r.adSetName}`.toLowerCase().includes(needle)), [leads, needle, newOnly]);
  const shownAds = useMemo(() => (ads || [])
    .filter((r) => !needle || `${r.campaignName} ${r.adSetName} ${r.adName}`.toLowerCase().includes(needle)), [ads, needle]);

  return (
    <div>
      <div className="page-header">
        <h2 style={{ fontSize: 16, fontWeight: 700, color: 'var(--navy)', margin: 0 }}>Facebook Leads</h2>
      </div>
      <div className="port-filters">
        <button type="button" className={`btn ${tab === 'leads' ? 'btn-primary' : 'btn-outline'}`} onClick={() => setTab('leads')}>Leads</button>
        <button type="button" className={`btn ${tab === 'ads' ? 'btn-primary' : 'btn-outline'}`} onClick={() => setTab('ads')}>Ad ROI</button>
        <input className="form-input" style={{ width: 240 }} value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search..." />
        {tab === 'leads' && (
          <select className="form-select" style={{ width: 'auto' }} value={newOnly} onChange={(e) => setNewOnly(e.target.value)}>
            <option value="all">All leads</option>
            <option value="Y">New customers</option>
            <option value="N">Existing customers</option>
          </select>
        )}
      </div>
      <div className="card">
        {error && <div style={{ padding: 16, fontSize: 12, color: 'var(--red)' }}>Error: {error}</div>}
        {!leads && !error && <div style={{ padding: 16, fontSize: 12, color: 'var(--gray-500)' }}>Loading...</div>}
        {leads && tab === 'leads' && (
          <div className="port-scroll">
            <table className="trans-table">
              <thead><tr><th>Email</th><th>Ad</th><th>New Customer</th><th>Orders</th><th>Orders Total</th><th>Net Profit</th></tr></thead>
              <tbody>
                {shownLeads.map((r, i) => (
                  <tr key={i}><td>{r.email}</td><td>{r.adName}</td><td>{r.newCustomer}</td><td>{r.numOfOrders}</td><td>{money(r.ordersTotal)}</td><td>{money(r.netProfit)}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {leads && tab === 'ads' && (
          <div className="port-scroll">
            <table className="trans-table">
              <thead><tr><th>Campaign</th><th>Ad Set</th><th>Ad</th><th>Spend</th><th>Leads</th><th>New Customers</th><th>Net Profit</th><th>ROI</th></tr></thead>
              <tbody>
                {shownAds.map((r, i) => (
                  <tr key={i}><td>{r.campaignName}</td><td>{r.adSetName}</td><td>{r.adName}</td><td>{money(r.spend)}</td><td>{r.leads}</td><td>{r.newCustomers}</td><td>{money(r.netProfit)}</td><td>{Number(r.roi || 0).toFixed(2)}%</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}